import React from 'react';

import LazyLoadedImage from 'common/LazyLoadedImage';
import VStack from 'common/ui/VStack';

import PurpleIcon from 'img/canny-icon.svg';

const AdminV2ErrorView = () => {
  return (
    <VStack className="box-border items-center justify-center gap-4 text-center h-[350px] w-full max-w-[350px] p-4">
      <LazyLoadedImage alt="Canny logo" className="h-[50px]" src={PurpleIcon} />
      <p className="text-red-90">
        Something went wrong. Try reloading the page. If the issue persists, please{' '}
        <a
          className="cursor-pointer underline transition-hover hover:text-red-110"
          href="mailto:support@canny.io"
          target="_blank"
          rel="noreferrer noopener">
          contact support
        </a>{' '}
        for assistance.
      </p>
    </VStack>
  );
};

export default AdminV2ErrorView;
